import logoBlack from '@/assets/icons/logo-black.png';

export const BrandLogo = () => {
  return (
    <div className="flex items-center -mb-8">
      <div
        className="w-[200px] h-[125px] bg-contain bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${logoBlack})` }}
      />
      <div className="text-brand-primary text-2xl ml-4">SeaWatch</div>
    </div>
  );
};
